import { defineStore } from "pinia";
import { api } from "@/shared/resource/apis/baseApi";
import { BUS_INFORMATION } from "@/shared/resource/constants";
import { BUS } from "@/shared/resource/apis/endpoints";
import { dateTime } from "@/shared/utills/date";

export const useBusStore = defineStore("bus", {
  state: () => ({
    buses: [],
    totalBuses: 0,
    busInformation: [...BUS_INFORMATION],
  }),

  actions: {
    async addBus(payload) {
      const response = await api.post(BUS.POST, payload);
      return response.data;
    },

    clearBuses() {
      this.buses = [];
      this.totalBuses = 0;
    },

    async deleteBus(id) {
      const response = await api.delete(BUS.DELETE(id));
      return response;
    },

    async fetch({ page = 1, limit = 10, filters = {} }) {
      this.clearBuses();

      const response = await api.get(BUS.GET, {
        params: { page_no: page, limit, ...filters },
      });
      const data = response?.data?.data || [];

      const formattedBuses = data.map((bus) => ({
        id: bus.bus_id,
        busNo: bus.reg_no,
        createdAt: dateTime.formatDateTime(bus.created_at),
        phoneNumber: bus.phone_number,
        routeDetails:
          bus.route?.length > 0
            ? `${bus.route[0].source}-${bus.route[0].destination}`
            : "N/A",
        revenue: bus.total_revenue,
        bookings: bus.total_bookings,
        onboardingProgress: `${bus.onboarding_progress}%`,
        status: bus.is_active,
      }));

      this.setBusInformation(response?.data);
      this.setBuses(formattedBuses, response?.data?.total_entries || 0);
      return formattedBuses;
    },

    setBuses(buses, total) {
      this.buses = buses;
      this.totalBuses = total;
    },

    setBusInformation(stats = {}) {
      this.busInformation[0].count = stats.active_buses || 0;
      this.busInformation[1].count = stats.in_complete_buses || 0;
      this.busInformation[2].count = stats.live_operators || 0;
    },

    async updateBus(id, payload) {
      const response = await api.put(BUS.UPDATE(id), payload);
      return response.data;
    },

    async uploadBusImage(busId, imageFile, imageType) {
      const formData = new FormData();
      formData.append("images", imageFile);
      formData.append("entity_id", busId);
      formData.append("entity_type", "bus");
      formData.append("image_type", imageType);

      const response = await api.post(BUS.UPLOAD_IMAGE, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    },

    async updateBusImage(imageId, imageFile, imageType) {
      const formData = new FormData();
      formData.append("images", imageFile);
      formData.append("image_type", imageType);

      const response = await api.patch(BUS.UPDATE_IMAGE(imageId), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    },

    async getBusById(id) {
      const response = await api.get(BUS.GET_BY_ID(id));
      return response.data;
    },

    async deleteBusImage(id) {
      const response = await api.delete(BUS.DELETE_IMAGE(id));
      return response.data;
    },
  },

  getters: {
    getBuses: (state) => state.buses,
    getTotalBuses: (state) => state.totalBuses,
    getBusInformation: (state) => state.busInformation,
  },
});
